<template>
    <v-data-table
        :headers="headers"
        :items="items"
        hide-actions
        disable-initial-sort
    >
        <template slot="headers">
          <tr>
            <th
              v-for="header in headers"
              :key="header.text"
              :class="[
                'column sortable',
                'text-xs-' + header.align,
              ]"
            >
              <span>{{ header.text }}</span>
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.index + 1 }}</td>
          <td class="text-xs-left">{{props.item.card_no}}</td>
          <td class="text-xs-left" style="width:80px">
            {{
              props.item.datetime
                ? $dateFormat(props.item.datetime, "YYYY-MM-DD")
                : "--"
            }}
          </td>
          <td class="text-xs-left ">
            {{
              props.item.datetime
                ? $dateFormat(props.item.datetime, "HH:mm")
                : "--"
            }}
          </td>
          <td class="text-xs-left text-uppercase">
            {{ props.item.control_no.toUpperCase() }}
          </td>
          <td class="text-xs-left text-uppercase" style="width: 70px">
            {{ props.item.or_no.toUpperCase() }}
          </td>
          <td class="text-xs-left text-uppercase">
            {{ props.item.device_serial ? props.item.device_serial : "" }}
          </td>
          <td class="text-xs-left text-uppercase">
            {{ props.item.location.toUpperCase() }}
          </td>
          <td class="text-xs-left text-uppercase">
            {{ props.item.terminal.toUpperCase() }}
          </td>
          <td class="text-xs-left text-uppercase">
            {{ props.item.type.toUpperCase() }}
          </td>
          <td class="text-xs-center text-uppercase">
            {{ $amountInPeso(props.item.transaction_amount) }}
          </td>
          <td class="text-xs-center text-uppercase">
            {{ $amountInPeso(props.item.remaining_balance) }}
          </td>
          <td class="text-xs-center text-uppercase">
            {{ $amountInPeso(props.item.previous_balance) }}
          </td>
          <td class="text-xs-center text-uppercase">
            {{ props.item.transaction_count ? props.item.transaction_count : "" }}
          </td>
          </template>
    </v-data-table>
</template>

<script>
export default {
  props: {
    items: Array,
  },
  data() {
    return {
      openViewDialog: false,
      rowsPerPageItems: [100, 200, 300, 400, 500],
      pagination: {
        itemsPerPage: 30,
        itemsLength: 30
      },
      headers: [
        { text: "#", align: "left", sortable: false },
      {
          text: "Card",
          align: "left",
          value: "code",
          sortable: false,
        },
        {
          text: "Date",
          align: "left",
          value: "transaction_date",
          sortable: false,
        },
        {
          text: "Time",
          align: "center",
          value: "transaction_time",
          sortable: true,
        },
        {
          text: "Control no.",
          align: "left",
          value: "control_no",
          sortable: true,
        },
        {
          text: "Or no.",
          align: "left",
          value: "or_no",
          sortable: true,
        },
        {
          text: "Device Serial",
          align: "left",
          value: "device_serial",
          sortable: false,
        },
        {
          text: "Location",
          align: "left",
          value: "location",
          sortable: true,
        },
        {
          text: "Terminal",
          align: "left",
          value: "terminal",
          sortable: true,
        },
        {
          text: "Transaction",
          align: "left",
          value: "transaction",
          sortable: false,
        },
        {
          text: "Transaction Amount",
          align: "center",
          value: "amount",
          sortable: false,
        },
        {
          text: "Remaining Balance",
          align: "center",
          value: "action",
          sortable: false,
        },
        {
          text: "Previous Balance",
          align: "center",
          value: "previous_balance",
          sortable: false,
        },
        {
          text: "Transaction Count",
          align: "center",
          value: "previous_count",
          sortable: false,
        },
      ],
    };
  },
  created() {},
  computed: {
    computedData() {
       return {
        items: this.items,
      };
    },
  },
  methods: {
  }
};
</script>

<style scoped>
.data-tab {
  border: 2px solid;
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 20px;
  table-layout: fixed;
}
.data-tabletab {
  width: 100%;
}
.td1 {
  border: 2px solid;
  padding-right: 10px;
  padding-left: 10px;
}

.table-controls {
  padding: 0 !important;
}
table.v-table td,
th {
  box-shadow: 1px 0px 0px 0px #eee;
}
table.v-table tbody tr {
  cursor: pointer !important;
}
.current-row {
  background-color: #ddd;
}
.row-active {
  box-shadow: 4px -1px 0px 0px rgb(76, 175, 80) inset;
}
.row-inactive {
  color: rgb(244, 67, 54);
  box-shadow: 4px 0px 0px 0px rgb(244, 67, 54) inset;
}
table.v-table td,
th {
  height: 30px !important;
  padding: 0px 5px 0px 5px !important;
}
table.v-table thead tr:not(.v-datatable__progress) {
  height: 30px;
}
</style>
